import { TableContainer, Tooltip } from '@mui/material';
import Section from 'pages/components/Section';
import { PaymentOut } from 'Domain/PaymentPlan/Entity/PaymentPlan';
import {
  formatDate,
  formatPercent,
  formatPrice,
  getDateFormat,
} from 'pages/Utils/Formats';
import moment from 'moment';
import PaymentOutStatusChip from 'pages/components/Status/PaymentOutStatusChip';
import CustomTable from 'pages/components/CustomTable';
import { useTranslation } from 'react-i18next';

type DisplayPaymentsInProps = {
  paymentsOut: Array<PaymentOut>;
};

export default function DisplayPaymentsOutDetails({
  paymentsOut,
}: DisplayPaymentsInProps) {
  const { t } = useTranslation();
  return (
    <Section title={'payments_out'} accordion={true} initOpen={true}>
      <TableContainer sx={{ marginTop: -3, marginBottom: -2 }}>
        <CustomTable
          data={formatPayout(paymentsOut, t)}
          horizontal={false}
          config={getTableConfig()}
        />
      </TableContainer>
    </Section>
  );
}

function formatPayout(paymentsOut: Array<PaymentOut>, t: Function) {
  const tableData: Array<any> = [];

  paymentsOut.forEach((paymentOut) => {
    const ttcFees = paymentOut.paymentAmount - paymentOut.toPayAmount;
    const feesAmount = (ttcFees * 100) / (100 + paymentOut.vat);
    const vatAmount = ttcFees - feesAmount;

    const fees =
      paymentOut.fees !== 0
        ? `${formatPrice(feesAmount)} (${formatPercent(paymentOut.fees)})`
        : '0%';

    const vat =
      paymentOut.vat !== 0
        ? `${formatPrice(vatAmount)} (${formatPercent(paymentOut.vat)})`
        : '0%';

    const paymentDate = moment(paymentOut.date).format(getDateFormat());

    const date = paymentOut.toPayCondition ? (
      <Tooltip
        title={t(`STATUS.PAYOUT.CONDITION.${paymentOut.toPayCondition}`, {
          session: paymentOut.sequence,
          activationDate: paymentOut.sessionLimitDate
            ? formatDate(paymentOut.sessionLimitDate)
            : '',
        })}
        placement="top"
        arrow={true}
      >
        <p>
          {paymentDate} <span style={{ fontWeight: 'bold' }}>*</span>
        </p>
      </Tooltip>
    ) : (
      paymentDate
    );

    tableData.push({
      sequence: paymentOut.sequence,
      date: date,
      paymentAmount: formatPrice(paymentOut.paymentAmount),
      fees: fees,
      vat: vat,
      toPayAmount: formatPrice(paymentOut.toPayAmount),
      status: <PaymentOutStatusChip status={paymentOut.status} />,
    });
  });

  return tableData;
}

function getTableConfig() {
  return {
    sequence: { sx: { width: '20px' } },
    status: { align: 'right' },
  };
}
